export const ASSET_IMAGE_MAX_SIZE_MB = 5;
export const ASSET_IMAGE_MAX_SIZE_BYTES = ASSET_IMAGE_MAX_SIZE_MB * 1024 * 1024;
export const ASSET_IMAGE_ACCEPTED_TYPES: readonly string[] = ['image/jpeg', 'image/png'];
